import React from 'react';
import CardButton from '../CardButton/CardButton';
import './HomeSlide.css';
import ProgressMeter from '../ProgressMeter/ProgressMeterTutor';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_overview} from '../../../../../cosmosTracking/cosmosEvents';
import Lottie from "react-lottie";
import holititle2 from '../../../../../assets/images/holi-homecard-2026.gif'
import revnuebar from '../../../../../assets/images/revenue_bar.png'
import holippl from '../../../../../assets/images/holi-people.png'
function HomeSlide(props) {
	const { data, campaignOrg, rewardText } = props;
	return (
		<div className="slideCard slideCardHome">
			<div className="cardBody">
				<img src={holippl} className='overlay-image' />
				<img className="home-top-img" src={holititle2} alt="signature"/>
				<hr className="img-border" />
				<div className="revenueData">
					<img
						src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/ractangle-hprizontal-stand.png"}
						alt="border" height={50} width={4}/>
					<div>
						<h4>{data?.revenueCard?.text}</h4>
						<h1>{data?.revenueCard?.total}</h1>
					</div>
				</div>
				<div className="meterData">
					<ProgressMeter width={data?.revenueCard?.percentage}/>
				</div>
				<div className="completeData">
					<p>{data?.revenueCard?.percentage}% complete</p>
					<p>Goal: {data?.revenueCard?.goal}</p>
				</div>
				<div className="pointDataGroup">
					<div className="pointData left-side-card">
						<p className='rank-data-card-title'>YOUR RANK</p>
						<div className='rank-data-card'>
								<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/rep-25-slide-1-medal-star26.png" width={16} height={20} alt="star"/>
								<h3>{data?.rankCard?.title} <span>{data?.rankCard?.subText}</span></h3>
						</div>
					</div>
					<div className="pointData right-side-card">
						<p className='rank-data-card-title'>TOTAL POINTS</p>
						<div className='rank-data-card'>
						<img
							src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/diwali-point-white-icon-26.png"
							alt="circle-point" width={20} height={20}/>
								<h3>{data?.pointsCard?.title} <span></span></h3>
						</div>
					</div>
				</div>
				<CardButton text={'See now'}
							deeplink={data?.deeplinkOverview}
							className={'btn-action'}
							eventCallback={() => {
								cosmosTrackService(view_overview)
							}}>
				</CardButton>
			</div>
		</div>
	);
}

export default HomeSlide;
